import { useState } from 'react';
import appConfig from './appConfig';
import { supabase } from './supabase';
import { fmtMoney, computeTax, totalLabel, rateLabel, normalizeTax } from './taxConfig'; // PATCH oct18-tax

// Quote the search text so a comma or bracket (for example Smith, John) does not break the filter
function orLikeQ(col, term) {
  var t = String(term).trim().replace(/\s+/g, ' ').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  return col + '.ilike."%' + t + '%"';
}

// PATCH oct21-ui-fix: autofill off on customer fields, light red x buttons
// PATCH oct21-ui-quote: line icons for the quote screen (same style as Help and Measurements)
var Q_ICONS = {
  arrowLeft: ["M19 12H5", "M12 19l-7-7 7-7"],
  search: [{ c: [11, 11, 7] }, "M21 21l-4.35-4.35"],
  x: ["M18 6L6 18", "M6 6l12 12"],
  chevronRight: ["M9 18l6-6-6-6"],
  file: ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z", "M14 2v6h6", "M8 13h8", "M8 17h5"],
  pencil: ["M12 20h9", "M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"],
  plus: ["M12 5v14", "M5 12h14"],
  check: ["M20 6L9 17l-5-5"],
  save: ["M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z", "M17 21v-8H7v8", "M7 3v5h8"],
  whatsapp: ["M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 21l2.1-5.4A8.5 8.5 0 1 1 21 11.5z", "M9 9.5c.5 2.5 2.5 4.5 5 5"],
  mail: ["M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z", "M22 6l-10 7L2 6"],
  window: ["M4 3h16v18H4z", "M12 3v18", "M4 12h16"],
  screen: ["M4 3h16v18H4z", "M4 9h16", "M4 15h16", "M10 3v18", "M16 3v18"],
  bolt: ["M13 2L3 14h9l-1 8 10-12h-9l1-8z"],
};
function QIcon({ name, size }) {
  var parts = Q_ICONS[name] || Q_ICONS.file;
  var s = size || 20;
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ display:'block', flexShrink:0 }}>
      {parts.map(function (p, i) { return typeof p === 'string' ? <path key={i} d={p} /> : <circle key={i} cx={p.c[0]} cy={p.c[1]} r={p.c[2]} />; })}
    </svg>
  );
}

function CustomerSearch({ onSelect, theme, C }) {
  var [query, setQuery] = useState('');
  var [results, setResults] = useState([]);
  var [searching, setSearching] = useState(false);

  async function search(val) {
    setQuery(val);
    if (!val.trim()) { setResults([]); return; }
    setSearching(true);
    var { data } = await supabase.from('customers').select('id, full_name, phone, email, area') // PATCH oct21-ui-quote: email for the Email button
      .eq('company_id', appConfig.companyId)
      .or(orLikeQ('full_name', val) + ',' + orLikeQ('phone', val)).limit(8);
    setResults(data || []); setSearching(false);
  }
  function fp(phone) {
    if (!phone) return '';
    var d = phone.replace(/\D/g, '');
    if (d.length===11 && d.startsWith('1')) d = d.slice(1);
    if (d.length===10) return '+1 ('+d.slice(0,3)+') '+d.slice(3,6)+'-'+d.slice(6);
    return phone;
  }
  // PATCH oct21-ui-quote: new search box and result rows
  var teal = C ? C.teal : '#4A7C7E';
  var dark = typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme') === 'dark';
  var tealT = dark ? '#7CC2BB' : teal;
  var txt = theme ? theme.text : '#1a1a1a'; var sub = theme ? theme.subText : '#555';
  var line = theme ? theme.cardBorder : '#e0e0e0';
  return (
    <div style={{ position:'relative' }}>
      <div style={{ display:'flex', alignItems:'center', gap:8, minHeight:44, background:theme?theme.inputBg:'white', border:'1px solid '+(theme?theme.inputBorder:'#ccc'), borderRadius:10, padding:'0 6px 0 12px' }}>
        <span style={{ color:sub }}><QIcon name="search" size={18} /></span>
        <input aria-label="Search customer" autoComplete="bp-off" placeholder="Search customer by name or phone" value={query} onChange={e=>search(e.target.value)}
          style={{ flex:1, minWidth:0, minHeight:42, border:'none', outline:'none', fontSize:15, background:'transparent', color:txt, fontFamily:'inherit' }} />
        {query!=='' && <button aria-label="Clear search" onClick={()=>{setQuery('');setResults([]);}} style={{ width:36,height:36,background:'transparent',border:'none',color:sub,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center' }}><QIcon name="x" size={16} /></button>}
      </div>
      {results.length>0 && (
        <div style={{ position:'absolute',top:'100%',left:0,right:0,background:theme?theme.card:'white',border:'1px solid '+line,borderRadius:10,zIndex:999,boxShadow:'0 4px 16px rgba(0,0,0,0.12)',marginTop:4,overflow:'hidden' }}>
          {results.map((cu,i)=>(
            <div key={cu.id} onClick={()=>{onSelect(cu);setQuery(cu.full_name);setResults([]);}}
              style={{ minHeight:56,padding:'8px 14px',borderTop:i?'1px solid '+line:'none',cursor:'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',gap:10 }}>
              <div style={{ minWidth:0 }}>
                <div style={{ fontSize:15,fontWeight:600,color:txt }}>{cu.full_name}</div>
                <div style={{ fontSize:13,color:sub }}>{[fp(cu.phone),cu.area].filter(Boolean).join(' · ')}</div>
              </div>
              <span style={{ color:tealT }}><QIcon name="chevronRight" size={20} /></span>
            </div>
          ))}
        </div>
      )}
      {searching && <div style={{ fontSize:13,color:sub,padding:'6px 12px' }}>Searching...</div>}
    </div>
  );
}

var TYPES = {
  blind: ['Roller Blind','Zebra Blind','Blackout Blind','Cellular / Honeycomb Blind','Venetian Blind','Roman Blind','Vertical Blind','Custom Blind'],
  screen: [{header:'── DOOR SCREENS ──'},'Patio Sliding Screen Door','Retractable Screen Door','Storm Door Screen',{header:'── WINDOW SCREENS ──'},'Regular Window Screen','Solar Window Screen','Pet-Proof Window Screen','Custom Screen'],
  automation: [{header:'── MOTORS ──'},'Standard Motor','Rechargeable Motor','Hardwired Motor','Solar-Powered Motor',{header:'── CONTROLS ──'},'Remote Control','Wall Switch','Comm Hub',{header:'── POWER ──'},'Charger','Solar Panel','Transformer',{header:'── OTHER ──'},'Custom Automation Item'],
};

function getFirstReal(list) { for (var i=0;i<list.length;i++) if (typeof list[i]==='string') return list[i]; return ''; }
function makeRow(kind) { return { id:Date.now()+Math.random(), type:getFirstReal(TYPES[kind]), qty:'', price:'', noTax:false }; }
// PATCH quote-inc-fmt
// PATCH oct18-tax: money() inside the component uses the company currency
function endDot(t) { t=String(t||'').trim(); return /\.$/.test(t) ? t : t+'.'; }

function pluralType(type, qty) {
  var n = parseInt(qty, 10);
  if (!(n > 1)) return type;
  if (/(s|sh|ch|x|z)$/i.test(type)) return type + 'es';
  return type + 's';
}

// plain = true for email (no WhatsApp bold stars, headings get a colon)
// PATCH oct18-tax: company tax lines and currency, No tax items marked
function buildMessage(name,date,blindRows,screenRows,autoRows,allCharges,tax,anyPriced,allPriced,notes,plain,money) {
  var N='\n';
  function head(t) { return plain ? t+':' : '*'+t+'*'; }
  var blocks=[];
  var nm=(name||'').trim();
  var markNoTax=tax.taxes.length>0;
  blocks.push(nm ? 'Hi '+nm+',' : 'Hi,');
  blocks.push('Thank you for your interest. Here is your quote from '+endDot(appConfig.companyFullName));
  blocks.push('Date: '+date);
  [{label:'Blinds',rows:blindRows},{label:'Screens',rows:screenRows},{label:'Automation',rows:autoRows}].forEach(s=>{
    if (!s.rows.length) return;
    var lines=[head(s.label)];
    s.rows.forEach(r=>{
      var q=parseInt(r.qty,10)||1;
      var line='• '+q+' '+pluralType(r.type,q);
      if (r.price!==''&&!isNaN(parseFloat(r.price))) line+=': '+money(parseFloat(r.price));
      if (markNoTax&&r.noTax) line+=' (no tax)';
      lines.push(line);
    });
    blocks.push(lines.join(N));
  });
  var ac=allCharges.filter(c=>c.on&&c.price&&parseFloat(c.price)>0);
  if (ac.length) {
    var cl=[head('Charges')];
    ac.forEach(c=>{ cl.push('• '+(c.label||'Other')+': '+money(parseFloat(c.price))+(markNoTax&&c.noTax?' (no tax)':'')); });
    blocks.push(cl.join(N));
  }
  if (anyPriced) {
    var tl=[];
    var tot;
    if (tax.mode==='included') {
      tot='Total: '+money(tax.total);
      tl.push(plain ? tot : '*'+tot+'*');
      tax.taxes.forEach(t=>{ tl.push('Includes '+t.name+' ('+rateLabel(t.rate)+'): '+money(t.amount)); });
    } else {
      tl.push('Subtotal: '+money(tax.subtotal));
      tax.taxes.forEach(t=>{ tl.push(t.name+' ('+rateLabel(t.rate)+'): '+money(t.amount)); });
      tot=totalLabel(tax.taxes)+': '+money(tax.total);
      tl.push(plain ? tot : '*'+tot+'*');
    }
    if (!allPriced) tl.push('(Some items not yet priced)');
    blocks.push(tl.join(N));
    var nums=tax.taxes.filter(t=>t.number).map(t=>t.name+' No. '+t.number);
    if (nums.length) blocks.push(nums.join(N));
  }
  if (notes&&notes.trim()) blocks.push(notes.trim());
  blocks.push('If you have any questions, please feel free to contact us.'+N+N+appConfig.companyFullName);
  return blocks.join(N+N);
}

// PATCH oct18-qedit: fill the quote screen from a saved quote
var CHARGE_KEYS=['installBlinds','removal','customBlinds','installScreens','customScreens','customAuto'];
function quoteInit(q) {
  var r = { blinds:null, screens:[], automation:[], ch:{}, chL:{}, noTax:{}, notes:'' };
  if (!q || !q.items) return r;
  function rows(list) {
    return (Array.isArray(list)?list:[]).map(function(x){
      return { id:Date.now()+Math.random(), type:x.type||'', qty:(x.qty===undefined||x.qty===null)?'':x.qty, price:(x.price===undefined||x.price===null)?'':String(x.price), noTax:!!x.noTax };
    });
  }
  r.blinds = rows(q.items.blinds);
  r.screens = rows(q.items.screens);
  r.automation = rows(q.items.automation);
  (Array.isArray(q.items.charges)?q.items.charges:[]).forEach(function(c,i){
    var k = (c && c.key) || CHARGE_KEYS[i];
    if (!c || !k) return;
    if (c.on && c.price!==undefined && c.price!==null && String(c.price)!=='') r.ch[k]=String(c.price);
    if (/^custom/.test(k) && c.label && c.label!=='Other charge') r.chL[k]=c.label;
    if (c.noTax) r.noTax[k]=true;
  });
  r.notes = q.notes || '';
  return r;
}

export default function QuoteTemplate({ customer, onClose, onSaved, theme, C, showToast, taxSettings, editQuote }) {
  // PATCH oct18-tax: company tax lines, tax mode and currency
  var taxCfg = normalizeTax(taxSettings);
  function money(n) { return fmtMoney(n, taxCfg.currency); }
  var [init] = useState(() => quoteInit(editQuote)); // PATCH oct18-qedit
  var IS = { minHeight:44, padding:'0 10px', borderRadius:10, border:'1px solid '+(theme?theme.inputBorder:'#ccc'), fontSize:15, background:theme?theme.inputBg:'white', color:theme?theme.text:'#1a1a1a', boxSizing:'border-box', width:'100%', fontFamily:'inherit' }; // PATCH oct21-ui-quote: bigger text

  var [tab,setTab]               = useState('blinds');
  var [custName,setCustName]     = useState((editQuote&&editQuote.customer_name)||(customer?customer.full_name||'':''));
  var [custPhone,setCustPhone]   = useState((editQuote&&editQuote.customer_phone)||(customer?customer.phone||'':''));
  var [blindRows,setBlindRows]   = useState(()=>init.blinds||[makeRow('blind')]);
  var [screenRows,setScreenRows] = useState(()=>init.screens);
  var [autoRows,setAutoRows]     = useState(()=>init.automation);
  var [notes,setNotes]           = useState(init.notes);
  var [saving,setSaving]         = useState(false);
  var [selectedCust,setSelectedCust] = useState(null);
  var [custEmail,setCustEmail] = useState(customer ? customer.email || '' : '');
  var [quoteSaved,setQuoteSaved] = useState(false);

  var [chInstallBlinds,setChInstallBlinds]   = useState(false);
  var [chInstallBlindsP,setChInstallBlindsP] = useState(init.ch.installBlinds||'');
  var [chRemoval,setChRemoval]               = useState(false);
  var [chRemovalP,setChRemovalP]             = useState(init.ch.removal||'');
  var [chCustomBlinds,setChCustomBlinds]     = useState(false);
  var [chCustomBlindsL,setChCustomBlindsL]   = useState(init.chL.customBlinds||'');
  var [chCustomBlindsP,setChCustomBlindsP]   = useState(init.ch.customBlinds||'');
  var [chInstallScreens,setChInstallScreens]   = useState(false);
  var [chInstallScreensP,setChInstallScreensP] = useState(init.ch.installScreens||'');
  var [chCustomScreens,setChCustomScreens]     = useState(false);
  var [chCustomScreensL,setChCustomScreensL]   = useState(init.chL.customScreens||'');
  var [chCustomScreensP,setChCustomScreensP]   = useState(init.ch.customScreens||'');
  var [chCustomAuto,setChCustomAuto]   = useState(false);
  var [chCustomAutoL,setChCustomAutoL] = useState(init.chL.customAuto||'');
  var [chCustomAutoP,setChCustomAutoP] = useState(init.ch.customAuto||'');
  var [chNoTax,setChNoTax] = useState(init.noTax); // PATCH oct18-tax: charges marked No tax

  var teal=C?C.teal:'#4A7C7E'; var red=C?C.red:'#B33A3A';
  var cardBg=theme?theme.card:'white'; var sectionBg=theme?theme.sectionBg:'#f7f8fa';
  var textColor=theme?theme.text:'#1a1a1a'; var subText=theme?theme.subText:'#555';
  var borderCol=theme?theme.cardBorder:'#e0e0e0';
  // PATCH oct21-ui-quote: shared styles for the new look (dark mode reads data-theme)
  var dark = typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme') === 'dark';
  var tealT = dark ? '#7CC2BB' : teal;
  var mutedText = theme && theme.mutedText ? theme.mutedText : subText;
  var greenC = C && C.green ? C.green : '#2F7D4F';
  var waGreen = '#1E7A45';
  var cardS = { background:cardBg, border:'1px solid '+borderCol, borderRadius:14, padding:16, marginBottom:12 };
  var secH = { fontSize:13, fontWeight:700, color:subText, textTransform:'uppercase', letterSpacing:0.5, marginBottom:8 };
  var hintS = { fontSize:13, color:mutedText, marginBottom:6, lineHeight:1.4 };
  var btnS = { minHeight:44, padding:'0 12px', background:sectionBg, color:textColor, border:'1px solid '+borderCol, borderRadius:10, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:6, fontSize:15, fontWeight:600, fontFamily:'inherit' };

  function numFocus(e) { e.target.select(); }

  function addRow(kind) {
    var r=makeRow(kind);
    if(kind==='blind') setBlindRows(p=>p.concat(r));
    if(kind==='screen') setScreenRows(p=>p.concat(r));
    if(kind==='automation') setAutoRows(p=>p.concat(r));
  }
  function delRow(kind,id) {
    var f=p=>p.filter(r=>r.id!==id);
    if(kind==='blind') setBlindRows(f); if(kind==='screen') setScreenRows(f); if(kind==='automation') setAutoRows(f);
  }
  function updateRow(kind,id,field,value) {
    var u=rows=>rows.map(r=>r.id!==id?r:Object.assign({},r,{[field]:value}));
    if(kind==='blind') setBlindRows(u); if(kind==='screen') setScreenRows(u); if(kind==='automation') setAutoRows(u);
  }
  function calcTotals(rows) {
    var priced=rows.filter(r=>r.price!==''&&!isNaN(parseFloat(r.price))&&parseFloat(r.price)>=0);
    return {priced,total:priced.reduce((s,r)=>s+parseFloat(r.price),0)};
  }

  var allCharges=[
    {key:'installBlinds',on:!!(chInstallBlindsP&&parseFloat(chInstallBlindsP)>0),label:'Installation (Blinds)',price:chInstallBlindsP},
    {key:'removal',on:!!(chRemovalP&&parseFloat(chRemovalP)>0),label:'Removal & Disposal',price:chRemovalP},
    {key:'customBlinds',on:!!(chCustomBlindsP&&parseFloat(chCustomBlindsP)>0),label:chCustomBlindsL||'Other charge',price:chCustomBlindsP},
    {key:'installScreens',on:!!(chInstallScreensP&&parseFloat(chInstallScreensP)>0),label:'Installation (Screens)',price:chInstallScreensP},
    {key:'customScreens',on:!!(chCustomScreensP&&parseFloat(chCustomScreensP)>0),label:chCustomScreensL||'Other charge',price:chCustomScreensP},
    {key:'customAuto',on:!!(chCustomAutoP&&parseFloat(chCustomAutoP)>0),label:chCustomAutoL||'Other charge',price:chCustomAutoP},
  ].map(c=>Object.assign(c,{noTax:!!chNoTax[c.key]})); // PATCH oct18-tax
  var chargesTotal=allCharges.reduce((s,c)=>s+(c.on&&c.price&&!isNaN(parseFloat(c.price))?parseFloat(c.price):0),0);
  var allRows=blindRows.concat(screenRows).concat(autoRows);
  var allPriced=allRows.filter(r=>r.price!==''&&!isNaN(parseFloat(r.price)));
  // PATCH oct18-tax: company tax lines instead of a fixed GST 5%
  var taxAmounts=allPriced.map(r=>({amount:parseFloat(r.price),noTax:!!r.noTax})).concat(allCharges.filter(c=>c.on&&c.price&&!isNaN(parseFloat(c.price))).map(c=>({amount:parseFloat(c.price),noTax:!!c.noTax})));
  var tax=computeTax(taxAmounts,taxCfg.lines,taxCfg.mode);
  var subtotal=tax.subtotal; var totalGst=tax.total;
  var anyPriced=allPriced.length>0||chargesTotal>0;
  var allHavePrice=allRows.length>0&&allPriced.length===allRows.length;
  var date=new Date().toLocaleDateString(appConfig.locale,{year:'numeric',month:'long',day:'numeric'});
  var waMessage=allRows.length>0?buildMessage(custName,date,blindRows,screenRows,autoRows,allCharges,tax,anyPriced,allHavePrice,notes,false,money):'';
  var emailMessage=allRows.length>0?buildMessage(custName,date,blindRows,screenRows,autoRows,allCharges,tax,anyPriced,allHavePrice,notes,true,money):'';

  async function saveQuote() {
    if (!allRows.length) { showToast('Add at least one item','error'); return; }
    // PATCH oct18-quotes: a quote must belong to a customer, or the user confirms a typed name
    var linkedCust = customer || selectedCust;
    if (!(linkedCust && linkedCust.id)) {
      if (!custName.trim()) { showToast('Please choose a customer from the search list first','error'); return; }
      if (!window.confirm("This customer is not linked to your customer list, so the quote will not show in their Quote History. Save anyway?")) return;
    }
    setSaving(true);
    var payload = {
      customer_name: custName,
      customer_phone: custPhone,
      items: {blinds:blindRows, screens:screenRows, automation:autoRows, charges:allCharges},
      subtotal: subtotal || 0,
      gst: tax.taxTotal || 0, // PATCH oct18-tax: total of all tax lines
      total: totalGst || 0,
      tax_lines: tax.taxes,
      tax_mode: tax.mode,
      currency: taxCfg.currency,
      notes: notes || '',
      whatsapp_message: waMessage || '',
    };
    var cust = customer || selectedCust;
    if (cust && cust.id) payload.contact_id = cust.id;
    payload.company_id = appConfig.companyId;
    var error = null;
    if (editQuote && editQuote.id) {
      // PATCH oct18-qedit: update the same quote, keep its date, mark it edited
      delete payload.company_id;
      payload.edited_at = new Date().toISOString();
      var upd = await supabase.from('quotes').update(payload, { count: 'exact' }).eq('id', editQuote.id);
      error = upd.error || (!upd.count ? { message: 'this quote could not be updated' } : null);
    } else {
      var ins = await supabase.from('quotes').insert([payload]);
      error = ins.error;
    }
    setSaving(false);
    if (error) { showToast('Error: ' + error.message, 'error'); return; }
    showToast(editQuote ? 'Quote updated! Now send via WhatsApp.' : 'Quote saved! Now send via WhatsApp.');
    setQuoteSaved(true);
  }
  function sendWhatsApp() {
    if (!allRows.length) { showToast('Add at least one item','error'); return; }
    if (!custPhone) { showToast('Please enter a phone number','error'); return; }
    if (!quoteSaved) { alert('Please save the quote first before sending.'); return; }
    window.open('https://wa.me/'+(function(d){return d.length===10?'1'+d:d;})(custPhone.replace(/\D/g,''))+'?text=' /* PATCH oct18-tax: country code */+encodeURIComponent(waMessage),'_blank');
  }

  function sendEmail() {
    if (!allRows.length) { showToast('Add at least one item','error'); return; }
    if (!quoteSaved) { alert('Please save the quote first before sending.'); return; }
    var subject = 'Quote from ' + appConfig.companyFullName;
    var body = emailMessage;
    var mailto = 'mailto:' + (custEmail||'') + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    window.open(mailto, '_blank');
  }

  // PATCH oct21-ui-quote: TAX chip (teal = tax applies, white = No tax)
  function taxChip(off, onTap, what) {
    return <button type="button" title={off?'No tax on this '+what+', tap to add tax':'Tax applies, tap for no tax'} aria-pressed={!off} onClick={onTap}
      style={{ minHeight:36,minWidth:64,padding:'0 10px',borderRadius:999,border:'1px solid '+(off?borderCol:teal),background:off?cardBg:teal,color:off?subText:'white',fontSize:13,fontWeight:700,cursor:'pointer',flexShrink:0,fontFamily:'inherit',whiteSpace:'nowrap' }}>{off?'No tax':'TAX'}</button>;
  }

  function renderRows(kind,rows) {
    return rows.map((row,ri)=>(
      <div key={row.id} style={{ padding:'10px 0', borderTop:ri?'1px solid '+borderCol:'none' }}>
        <select aria-label="Type" value={row.type} onChange={e=>updateRow(kind,row.id,'type',e.target.value)} style={Object.assign({},IS,{marginBottom:8})}>
          {TYPES[kind].map((t,i)=>typeof t==='object'&&t.header
            ?<option key={i} disabled style={{color:'#888'}}>{t.header}</option>
            :<option key={i} value={t}>{t}</option>)}
        </select>
        <div style={{ display:'grid', gridTemplateColumns:'64px 1fr auto 40px', gap:8, alignItems:'center' }}>
          <input aria-label="Quantity" type="number" inputMode="numeric" min="1" placeholder="Qty" value={row.qty}
            onFocus={e => { if(e.target.value === '1') { updateRow(kind, row.id, 'qty', ''); } else e.target.select(); }}
            onBlur={e => { if(!e.target.value || e.target.value === '0') updateRow(kind, row.id, 'qty', 1); }}
            onChange={e=>updateRow(kind,row.id,'qty',e.target.value===''?'':parseInt(e.target.value)||1)}
            style={Object.assign({},IS,{textAlign:'center'})} />
          <input aria-label="Line total" type="number" inputMode="decimal" min="0" placeholder="Total (optional)" value={row.price}
            onFocus={numFocus}
            onChange={e=>updateRow(kind,row.id,'price',e.target.value)}
            style={Object.assign({},IS,{textAlign:'right',minWidth:0})} />
          {taxChip(!!row.noTax, ()=>updateRow(kind,row.id,'noTax',!row.noTax), 'item')}
          <button type="button" aria-label="Remove line" title="Remove line" onClick={()=>delRow(kind,row.id)} style={{ width:40,height:40,borderRadius:10,background:dark?'#3A1F1D':'#FBEAE8',border:'none',color:dark?'#F0776B':red,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',padding:0 }}><QIcon name="x" size={18} /></button>
        </div>
      </div>
    ));
  }

  function Checkbox({on,onToggle}) {
    return (
      <div onMouseDown={e=>{e.preventDefault();onToggle();}} style={{ width:20,height:20,borderRadius:5,border:'2px solid '+teal,background:on?teal:'transparent',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,cursor:'pointer' }}>
        {on && <span style={{ color:'white',fontSize:13,fontWeight:'bold',lineHeight:1 }}>✓</span>}
      </div>
    );
  }

  function ChargeRow({on,onToggle,label,labelEditable,labelValue,onLabelChange,price,onPriceChange}) {
    var inp={padding:'5px 8px',borderRadius:6,border:'1px solid '+borderCol,fontSize:13,background:on?(theme?theme.inputBg:'white'):sectionBg,color:textColor,opacity:on?1:0.4};
    return (
      <div style={{ display:'flex',alignItems:'center',gap:8,padding:'10px 0',borderBottom:'1px solid '+borderCol }}>
        <Checkbox on={on} onToggle={onToggle} />
        <div style={{ flex:1 }}>
          {labelEditable
            ?<input placeholder="Other charge..." defaultValue={labelValue} onBlur={e=>onLabelChange(e)} disabled={!on} inputMode="text" autoComplete="off" autoCorrect="off" style={Object.assign({},inp,{width:'100%',boxSizing:'border-box'})} />
            :<div style={{ fontSize:13,fontWeight:'500',color:on?textColor:subText }}>{label}</div>}
        </div>
        <input type="number" min="0" placeholder="—" value={price}
          onFocus={numFocus} onChange={onPriceChange} disabled={!on}
          style={Object.assign({},inp,{width:86,textAlign:'right'})} />
      </div>
    );
  }

  // PATCH oct21-ui-quote: Tax chip for a charge (tap to make it No tax)
  function chargeTaxBtn(key) {
    return taxChip(!!chNoTax[key], ()=>setChNoTax(p=>Object.assign({},p,{[key]:!p[key]})), 'charge');
  }

  function renderCharges(tabKey) {
    var row={display:'flex',alignItems:'center',gap:8,padding:'10px 0',borderTop:'1px solid '+borderCol};
    var lab={fontSize:15,fontWeight:500,color:textColor,flex:1,minWidth:0};
    var amt=Object.assign({},IS,{width:96,flexShrink:0,textAlign:'right'});
    var nameI=Object.assign({},IS,{flex:1,minWidth:0,width:'auto'});
    function fixed(label,key,val,set) {
      return (
        <div style={row}>
          <div style={lab}>{label}</div>
          {chargeTaxBtn(key)}
          <input aria-label={label+' amount'} type="number" inputMode="decimal" min="0" placeholder="Amount" value={val} onFocus={numFocus} onChange={e=>set(e.target.value)} style={amt} />
        </div>
      );
    }
    function custom(key,lv,setL,val,set) {
      return (
        <div style={row}>
          <input aria-label="Other charge name" placeholder="Other charge" value={lv} onChange={e=>setL(e.target.value)} style={nameI} />
          {chargeTaxBtn(key)}
          <input aria-label="Other charge amount" type="number" inputMode="decimal" min="0" placeholder="Amount" value={val} onFocus={numFocus} onChange={e=>set(e.target.value)} style={amt} />
        </div>
      );
    }
    return (
      <div style={cardS}>
        <div style={secH}>Charges</div>
        <div style={hintS}>Enter an amount to include a charge. Leave it blank to skip it.</div>
        {tabKey==='blinds' && <>
          {fixed('Installation','installBlinds',chInstallBlindsP,setChInstallBlindsP)}
          {fixed('Removal & Disposal','removal',chRemovalP,setChRemovalP)}
          {custom('customBlinds',chCustomBlindsL,setChCustomBlindsL,chCustomBlindsP,setChCustomBlindsP)}
        </>}
        {tabKey==='screens' && <>
          {fixed('Installation','installScreens',chInstallScreensP,setChInstallScreensP)}
          {custom('customScreens',chCustomScreensL,setChCustomScreensL,chCustomScreensP,setChCustomScreensP)}
        </>}
        {tabKey==='automation' && custom('customAuto',chCustomAutoL,setChCustomAutoL,chCustomAutoP,setChCustomAutoP)}
      </div>
    );
  }

  var tabDefs=[{key:'blinds',label:'Blinds',icon:'window',kind:'blind',rows:blindRows},{key:'screens',label:'Screens',icon:'screen',kind:'screen',rows:screenRows},{key:'automation',label:'Automation',icon:'bolt',kind:'automation',rows:autoRows}]; // PATCH oct21-ui-quote
  var blindQty=blindRows.reduce((s,r)=>s+(parseInt(r.qty,10)||0),0); var screenQty=screenRows.reduce((s,r)=>s+(parseInt(r.qty,10)||0),0); var autoQty=autoRows.reduce((s,r)=>s+(parseInt(r.qty,10)||0),0);

  return (
    <div style={{ fontFamily:'inherit',maxWidth:600,margin:'0 auto',padding:16,background:theme?theme.bg:'#f0f2f5',minHeight:'100vh',paddingBottom:40,boxSizing:'border-box' }}>
      {/* PATCH oct21-ui-quote: header like Measurements and Help */}
      <div style={Object.assign({},cardS,{padding:'10px 14px',display:'flex',alignItems:'center',gap:12})}>
        <button type="button" onClick={onClose} aria-label="Back" style={btnS}><QIcon name="arrowLeft" size={18} /> Back</button>
        <span style={{ color:tealT }}><QIcon name={editQuote?'pencil':'file'} size={22} /></span>
        <div style={{ minWidth:0 }}>
          <div style={{ fontSize:22,fontWeight:700,color:textColor,lineHeight:1.2 }}>{editQuote?'Edit Quote':'New Quote'}</div>
          <div style={{ fontSize:13,color:mutedText,marginTop:2 }}>{date}</div>
        </div>
      </div>

      <div style={cardS}>
        <div style={secH}>Customer</div>
        {!customer && (
          <div style={{ marginBottom:10 }}>
            <CustomerSearch onSelect={cu=>{setCustName(cu.full_name||'');setCustPhone(cu.phone||'');setCustEmail(cu.email||'');setSelectedCust(cu);}} theme={theme} C={C} />
            <div style={{ fontSize:13,color:mutedText,marginTop:6,textAlign:'center' }}>or type a name and phone below</div>
          </div>
        )}
        <div style={{ display:'flex',gap:8 }}>
          <input aria-label="Customer name" autoComplete="bp-off" placeholder="Customer name" value={custName} onChange={e=>setCustName(e.target.value)} style={Object.assign({},IS,{flex:1,minWidth:0})} />
          <input aria-label="Phone" autoComplete="bp-off" type="tel" inputMode="tel" placeholder="Phone" value={custPhone} onChange={e=>setCustPhone(e.target.value)} style={Object.assign({},IS,{flex:0.8,minWidth:0})} />
        </div>
      </div>

      <div style={{ display:'flex',gap:8,marginBottom:12 }}>
        {tabDefs.map(t=>{
          var active=tab===t.key; var qty=t.key==='blinds'?blindQty:t.key==='screens'?screenQty:autoQty;
          return (
            <button type="button" key={t.key} onClick={()=>setTab(t.key)} aria-pressed={active}
              style={{ flex:1,minWidth:0,minHeight:64,padding:'6px 4px',borderRadius:12,border:'1px solid '+(active?teal:borderCol),background:active?teal:cardBg,color:active?'white':textColor,fontSize:14,fontWeight:600,cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:3,fontFamily:'inherit' }}>
              <span style={{ color:active?'white':tealT }}><QIcon name={t.icon} size={20} /></span>
              {t.label}
              {qty>0 && <span style={{ fontSize:12,fontWeight:500,opacity:0.85 }}>{qty} unit{qty===1?'':'s'}</span>}
            </button>
          );
        })}
      </div>

      {tabDefs.map(t=>{
        if (tab!==t.key) return null;
        return (
          <div key={t.key}>
            <div style={cardS}>
              <div style={secH}>{t.label}</div>
              <div style={hintS}>Pick the type, then enter the quantity and the line total (optional).</div>
              {renderRows(t.kind,t.rows)}
              <button type="button" onClick={()=>addRow(t.kind)} style={Object.assign({},btnS,{width:'100%',background:'transparent',border:'1px dashed '+borderCol,color:tealT,marginTop:6})}>
                <QIcon name="plus" size={18} /> Add {t.key==='blinds'?'blind':t.key==='screens'?'screen':'automation'} item
              </button>
            </div>
            {renderCharges(t.key)}
          </div>
        );
      })}

      <div style={cardS}>
        <div style={secH}>Notes (optional)</div>
        <textarea aria-label="Notes" placeholder="For example: includes installation, free measurement" value={notes} onChange={e=>setNotes(e.target.value)}
          style={Object.assign({},IS,{minHeight:80,padding:10,resize:'vertical',lineHeight:1.5})} />
      </div>

      <div style={cardS}>
        <div style={secH}>Summary</div>
        {[{label:'Blinds',rows:blindRows},{label:'Screens',rows:screenRows},{label:'Automation',rows:autoRows}].map(s=>{
          if (!s.rows.length) return null;
          var qty=s.rows.reduce((a,r)=>a+(parseInt(r.qty,10)||0),0); var ct=calcTotals(s.rows);
          return (
            <div key={s.label} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',gap:8,padding:'8px 0',borderBottom:'1px solid '+borderCol }}>
              <span style={{ fontSize:15,color:textColor }}>{s.label} <span style={{ color:subText }}>({qty} unit{qty===1?'':'s'})</span></span>
              <span style={{ fontSize:15,fontWeight:700,color:textColor }}>{ct.priced.length>0?money(ct.total):'TBD'}</span>
            </div>
          );
        })}
        {allCharges.map((ch,i)=>{
          if (!ch.on||!ch.price||isNaN(parseFloat(ch.price))) return null;
          return (
            <div key={i} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',gap:8,padding:'8px 0',borderBottom:'1px solid '+borderCol }}>
              <span style={{ fontSize:15,color:textColor }}>{ch.label}</span>
              <span style={{ fontSize:15,fontWeight:700,color:textColor }}>{money(parseFloat(ch.price))}</span>
            </div>
          );
        })}
        <div style={{ paddingTop:10 }}>
          <div style={{ display:'flex',justifyContent:'space-between',marginBottom:6 }}>
            <span style={{ fontSize:15,color:subText }}>{tax.mode==='included'?'Before tax':'Subtotal'}</span>
            <span style={{ fontSize:15,fontWeight:700,color:textColor }}>{anyPriced?money(subtotal):'TBD'}</span>
          </div>
          {tax.taxes.map((t,ti)=>(
            <div key={'tx'+ti} style={{ display:'flex',justifyContent:'space-between',marginBottom:ti===tax.taxes.length-1?10:4 }}>
              <span style={{ fontSize:14,color:subText }}>{(tax.mode==='included'?'Includes ':'')+t.name+' ('+rateLabel(t.rate)+')'}</span>
              <span style={{ fontSize:14,color:subText }}>{anyPriced?money(t.amount):'—'}</span>
            </div>
          ))}
          {tax.taxes.length===0 && <div style={{ marginBottom:10 }}></div>}
          <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',gap:8,borderTop:'1px solid '+borderCol,paddingTop:10 }}>
            <span style={{ fontSize:17,fontWeight:700,color:textColor }}>{tax.mode==='included'?'Total':totalLabel(tax.taxes)}</span>
            <span style={{ fontSize:28,fontWeight:700,color:tealT }}>{anyPriced?money(totalGst):'TBD'}</span>
          </div>
          {!allHavePrice&&anyPriced&&<div style={{ fontSize:13,color:mutedText,marginTop:4 }}>Some items not yet priced</div>}
          {tax.taxes.filter(t=>t.number).map((t,ti)=><div key={'tn'+ti} style={{ fontSize:13,color:mutedText,marginTop:4 }}>{t.name} No. {t.number}</div>)}
          {tax.hasUntaxed&&tax.taxes.length>0&&<div style={{ fontSize:13,color:mutedText,marginTop:4 }}>Some items have no tax</div>}
        </div>
      </div>

      {allRows.length>0 && (
        <div style={cardS}>
          <div style={secH}>WhatsApp preview</div>
          <div style={{ background:sectionBg,borderRadius:10,padding:12,fontSize:14,color:textColor,whiteSpace:'pre-wrap',lineHeight:1.6,maxHeight:260,overflowY:'auto',border:'1px solid '+borderCol }}>
            {waMessage}
          </div>
        </div>
      )}

      {/* PATCH oct21-ui-quote: Save on top, WhatsApp and Email side by side */}
      <button type="button" onClick={saveQuote} disabled={saving} style={Object.assign({},btnS,{width:'100%',minHeight:52,background:saving?sectionBg:quoteSaved?greenC:teal,color:saving?subText:'white',border:'none',fontSize:16,fontWeight:700,cursor:saving?'not-allowed':'pointer',marginBottom:10})}>
        <QIcon name={quoteSaved?'check':'save'} size={20} /> {saving?'Saving...':quoteSaved?'Quote saved':editQuote?'Update Quote':'Save Quote'}
      </button>
      <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:10 }}>
        <button type="button" onClick={sendWhatsApp} style={Object.assign({},btnS,{minHeight:52,background:waGreen,color:'white',border:'none',opacity:quoteSaved?1:0.55})}><QIcon name="whatsapp" size={20} /> WhatsApp</button>
        <button type="button" onClick={sendEmail} style={Object.assign({},btnS,{minHeight:52,background:cardBg,opacity:quoteSaved?1:0.55})}><QIcon name="mail" size={20} /> Email</button>
      </div>
      {!quoteSaved && <div style={{ fontSize:13,color:mutedText,textAlign:'center',marginTop:8 }}>Save the quote first, then send it.</div>}
    </div>
  );
}
